import { useEffect } from 'react';
import LocalGuides from './LocalGuides';

export default function GuidesPage() {
  useEffect(() => {
    const title = 'Local guides | Turtle Island Cottage';
    const description =
      'Explore all our local guides to Garden Bay and the Sunshine Coast, from lake days to forest trails and weekend itineraries.';
    const url = 'https://turtleislandcottage.com/guides/';
    document.title = title;
    document.querySelector('link[rel="canonical"]')?.setAttribute('href', url);
    const metadata = {
      'meta[name="description"]': description,
      'meta[property="og:title"]': title,
      'meta[name="twitter:title"]': title,
      'meta[property="og:description"]': description,
      'meta[name="twitter:description"]': description,
      'meta[property="og:url"]': url,
      'meta[property="og:type"]': 'website'
    };
    Object.entries(metadata).forEach(([selector, content]) => {
      document.querySelector(selector)?.setAttribute('content', content);
    });
  }, []);

  return (
    <>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:block focus:p-4"
      >
        Skip to content
      </a>
      <header className="border-b border-forest/10 bg-birch">
        <nav
          aria-label="Guide navigation"
          className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-4 px-4 py-5"
        >
          <a
            href="/"
            className="font-display text-xl font-semibold italic text-forest"
          >
            Turtle Island Cottage
          </a>
          <a
            href="/#contact"
            className="text-sm font-semibold text-forest underline underline-offset-4"
          >
            Ask about a stay
          </a>
        </nav>
      </header>
      <main id="main-content">
        <div className="mx-auto max-w-6xl px-4 py-12 sm:py-16">
          <h1 className="font-display text-4xl font-semibold leading-tight text-forest sm:text-6xl">
            Local guides
          </h1>
          <p className="mt-5 max-w-2xl text-lg text-bark/75">
            Discover places to explore and ways to unwind near Turtle Island
            Cottage. Browse all our guides to plan your Sunshine Coast stay.
          </p>
        </div>
        <LocalGuides />
      </main>
    </>
  );
}
